import React, { useState, useRef, useEffect, useCallback, use } from "react";
import Header from "../../components/Header";
import PatientWrapper from "../../components/PatientWrapper";
import axios from "../../plugins/axios";
import SettingsModal from "../Settings/index";
import BedSettingsModal from "../BedSettings/index";
import Measurements from '../Measurements'
import UserInfoModal from '../UserInfo'
import UserSettingModal from "../UserSetting"
import AlarmReview from "../../components/AlarmReview";
import OneBed from "../../components/OneBed";
import Modal from '../../components/Modal';
import DeepSightInfo from '../../components/DeepSightInfo';
import LogoImage from "../../assets/img/logo.svg";
import { useRecoilState , useSetRecoilState } from "recoil";
import Toast from "../../plugins/useToast";
import SockJS from 'sockjs-client'
import { Client } from '@stomp/stompjs'
import { useTranslation } from 'react-i18next'
import { useBedData } from '../../context/BedDataContext';
import { decodeAndDecompress, parameterArrayToObject } from '../../plugins/common'
import {
  isFromSearchState,
  stompClientState,
  monitorState,
  unitState,
  wardState,
  bedCountState,
  bedSocketState,
  bedInfoState,
  selectBedInfoState,
  wardSuspendState,
  audioPlayState,
  globalParameterColorState,
  defaultWaveParameterColors,
  defaultNumericParameterColors,
  demoModeState,
  deviceModelInfo,
  v20DatasState,
  hl7InfoStatus
} from "../../plugins/recoil";
import router from '../../router'
import moment from 'moment';
import i18n from "../../locales/i18n";

import LeadModal from "./LeadModal";
import AudioModal from "./AudioModal";
import SearchPatientModal from '../../components/SearchPatientModal'
import TrendReview from "../../components/TrendReview";
import TrendReviewV20 from "../../components/TrendReviewV20";

import "./index.scss";
import useAlarm from "../../components/useAlarm";
import { set } from "lodash";
const Dashboard = () => {
  const { t } = useTranslation();
  const isFirstRender = useRef(true);
  // const socketUrl = "ws://3.37.140.239:6180/api/dashboard/vital-signs"; 
  // const socketUrl = "http://192.168.21.237:8081/ws";
  // const socketUrl = "http://192.168.21.237:8082/ws";
  const socketUrl = `${process.env.REACT_APP_SOCKET_URL}/ws`;
  // const [bedInfo, setBedInfo] = useState([])
  // const [bedData, setBedData] = useState({})
  // Recoil 상태 불러오기 
  const [isFromSearch, setIsFromSearch] = useRecoilState(isFromSearchState);
  const [stompClient, setStompClient] = useRecoilState(stompClientState)
  const [curMonitor, setCurMonitor] = useRecoilState(monitorState)
  const [curWard, setCurWard] = useRecoilState(wardState);
  const [cnt, setCnt] = useRecoilState(bedCountState);
  const [socketInfo, setSocketInfo] = useRecoilState(bedSocketState);
  const [bedInfo, setBedInfo] = useRecoilState(bedInfoState);
  // const [bedData, setBedData] = useRecoilState(bedDataState)
  const { bedDataRef, bedDataSnapshot, createSnapshot, updateBedData } = useBedData();
  const [selectBedInfo, setSelectBedInfo] = useRecoilState(selectBedInfoState);
  const [, setParameterColors] = useRecoilState(globalParameterColorState);
  const [isDemoMode, setDemoModeState] = useRecoilState(demoModeState);
  const [activePanel, setActivePanel] = useState(null); //setting ,trend,alarmReview, bedSettings 하나로 합치기
  const [fullPanel, setFullPanel] = useState(null); // trend, alarmReview
  const socketRef = useRef(null);
  const audioSocketRef = useRef(null)
  const fullScreenRef = useRef(0);
  const leftPatientWrapperRef = useRef(null);
  const rightPatientWrapperRef = useRef(null);
  const searchModalRef = useRef(null)
  const leadModalRef = useRef(null)
  const audioControlRef = useRef(null)
  const [wardSuspend, setWardSuspend] = useRecoilState(wardSuspendState);
  const [playAudio, setPlayAudio] = useRecoilState(audioPlayState);
  const [wardStatusChangeFlag, setWardStatusChangeFlag] = useState(0)  
  const [units, setUnits] = useRecoilState(unitState)
  const [isLogoutConfirmOpen, setIsLogoutConfirmOpen] = useState(false)
  const [isStandByConfirmOpen, setIsStandByConfirmOpen] = useState(false)
  const [standByDevice, setStandByDevice] = useState(null);
  const [patientIdx, setPatientIdx] = useState(null);
  const [searchModalShow, setSearchModalShow] = useState(false);
  const [leadModalShow, setLeadModalShow] = useState(false)
  const [audioModalShow, setAudioModalShow] = useState(false)
  const [audioErrorType, setAudioErrorType] = useState('warning')
  const [audioDismiss, setAudioDismiss] = useState(false)

  const [isPrintCountOpen, setIsPrintCountOpen] = useState(false)
  const [isDeepSightInfoOpen, setIsDeepSightInfoOpen] = useState(false)
  const [printCountdown, setPrintCountdown] = useState(15);
  const [, setDeviceModelInfo] = useRecoilState(deviceModelInfo);
  const [v20Datas,] = useRecoilState(v20DatasState); 
  const [, setHl7Info] = useRecoilState(hl7InfoStatus);

  // 배치 업데이트를 위한 ref 추가
  const batchUpdateRef = useRef({});
  const batchIntervalRef = useRef({});
  const bedInfoQueueRef = useRef({});
  const isBedInfoProcessingRef = useRef({});
  // 🔥 bedDataVersionRef, nonWaveBufferRef 유지
  const bedDataVersionRef = useRef(0);
  const nonWaveBufferRef = useRef({});

  // 큐에서 하나씩 꺼내서 순차 처리
  const processBedInfoQueue = async (serial) => {
    if (isBedInfoProcessingRef.current[serial]) return;
    isBedInfoProcessingRef.current[serial] = true;

    console.log(`[bedInfoQueue][${serial}] 큐 처리 시작, 대기 중: ${bedInfoQueueRef.current[serial]?.length}건`);

    while (bedInfoQueueRef.current[serial]?.length > 0) {
      const data = bedInfoQueueRef.current[serial].shift();
      console.log(`[bedInfoQueue][${serial}] 처리 중 - data:`, data);

      try {
        // Case 1: socket에서 받은 devicePatientId가 있는 경우에는 무조건 입원 상태
        if (data.devicePatientId) {                    
          console.log(`[bedInfoQueue][${serial}] Case1 - devicePatientId: ${data.devicePatientId}`);

          setBedInfo((prevBedInfo) => {
            return prevBedInfo.map(bedList => {
              return bedList.map(bedItem => {
                if (bedItem.serial !== serial) return bedItem;               

                // Case 1-2: 그 외 (환자 이동 없음) → bedNumber, patientName, devicePatientId만 업데이트
                return {
                  ...bedItem,
                  bedNumber: data.bedNumber ? Number(data.bedNumber) : bedItem.bedNumber,
                  patientName: data.name,
                  devicePatientId: data.devicePatientId
                }
              })
            })
          });
          console.log(`[bedInfoQueue][${serial}] Case1 완료 - devicePatientId: ${data.devicePatientId}`);

        // Case 2: socket에서 받은 devicePatientId가 없거나 null인 경우 → 해당 장비에서 퇴원 처리
        } else {
          console.log(`[bedInfoQueue][${serial}] Case2 - devicePatientId 없음 → 퇴원 처리`);

          setBedInfo((prevBedInfo) => {
            return prevBedInfo.map(bedList => {
              return bedList.map(bedItem => {
                if (bedItem.serial !== serial) return bedItem;
                return {
                  ...bedItem,
                  patientId: null,
                  bedNumber: data.bedNumber ? Number(data.bedNumber) : bedItem.bedNumber,
                  patientName: null,
                  devicePatientId: null
                }
              })
            })
          });
          console.log(`[bedInfoQueue][${serial}] Case2 완료 - patientId/patientName/devicePatientId → null`);
        }
      } catch (err) {
        console.warn(`[bedInfoQueue][${serial}] Error:`, err);
        // API 실패 시 기본 업데이트
        setBedInfo((prevBedInfo) => {
          return prevBedInfo.map(bedList => {
            return bedList.map(bedItem => {
              if (bedItem.serial !== serial) return bedItem;
              return {
                ...bedItem,
                bedNumber: data.bedNumber ? Number(data.bedNumber) : bedItem.bedNumber,
                patientName: data.name || null,
                devicePatientId: data.devicePatientId || null
              }
            })
          })
        });
        console.log(`[bedInfoQueue][${serial}] Error 후 기본 업데이트 완료`);
      }
    }

    console.log(`[bedInfoQueue][${serial}] 큐 처리 완료`);
    isBedInfoProcessingRef.current[serial] = false;
  };

  const connectWebsocket = (bedInfoList) => {

    //Out Of Memory 방지 위해 기존 소켓 연결과 인터벌 정리
    Object.values(batchIntervalRef.current).forEach(interval => {
      if (interval) clearInterval(interval);
    });
    batchIntervalRef.current = {};
    batchUpdateRef.current = {};

    if (socketRef.current) {
      socketRef.current.deactivate();
      socketRef.current = null;
      setStompClient(null)
    }
    
    const token = localStorage.getItem('accessToken')
    const socket = new SockJS(isDemoMode ? `${socketUrl}-demo?token=${token}` : `${socketUrl}?token=${token}`);
    socketRef.current = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,  // 서버로부터 heartbeat 수신 간격
      heartbeatOutgoing: 4000,  // 서버로 heartbeat 전송 간격
      onConnect: () => {
        console.log('[STOMP] Connected');                

        // 중복 serial 확인
        const serialList = bedInfoList.map(b => b.serial);
        const duplicates = serialList.filter((s, i) => serialList.indexOf(s) !== i);
        if (duplicates.length > 0) {
          console.warn('[STOMP] ⚠️ 중복 serial 발견:', duplicates);
        }

        // 각 디바이스별로 subscribe
        bedInfoList.forEach(({serial}, index) => {          
          batchUpdateRef.current[serial] = { waveData: {}, dirty: false };
        
          // ❌ serial별 setInterval 제거
          // batchIntervalRef.current[serial] = setInterval(() => { ... }, 500);

          const waveTopic = `${isDemoMode ? '/demo' : ''}/topic/data/wave/${serial}`;
          socketRef.current.subscribe(waveTopic, (message) => {
            const decompressed = decodeAndDecompress(message.body)
            if (decompressed) {
              const data = JSON.parse(decompressed);
              if (!batchUpdateRef.current[serial]) {
                batchUpdateRef.current[serial] = { waveData: {}, dirty: false };
              }
              const batch = batchUpdateRef.current[serial];
              Object.keys(data).forEach((key) => {
                if (!batch.waveData[key]) {
                  batch.waveData[key] = [];
                }
                // 🔥 concat 대신 push — 새 배열 생성 안 함
                const arr = batch.waveData[key];
                const newArr = data[key];
                for (let i = 0; i < newArr.length; i++) {
                  arr.push(newArr[i]);
                }
              });
              batch.dirty = true;
            }
          });

          const numericTopic = `${isDemoMode ? '/demo' : ''}/topic/data/numeric/${serial}`
          socketRef.current.subscribe(numericTopic, (message) => {
            const decompressed = decodeAndDecompress(message.body)
            if (decompressed) {
              const data = JSON.parse(decompressed);
              // 🔥 bedDataRef 전체 복사 대신 버퍼에 축적
              if (!nonWaveBufferRef.current[serial]) {
                nonWaveBufferRef.current[serial] = {};
              }
              if (!nonWaveBufferRef.current[serial].numericData) {
                nonWaveBufferRef.current[serial].numericData = {};
              }
              Object.assign(nonWaveBufferRef.current[serial].numericData, data);
              nonWaveBufferRef.current[serial]._dirty = true;
            }
          })

          const settingTopic = `${isDemoMode ? '/demo' : ''}/topic/data/settings/${serial}`
          socketRef.current.subscribe(settingTopic, (message) => {
            const decompressed = decodeAndDecompress(message.body)
            if (decompressed) {
              const data = JSON.parse(decompressed);
              if (!nonWaveBufferRef.current[serial]) {
                nonWaveBufferRef.current[serial] = {};
              }
              if (!nonWaveBufferRef.current[serial].settingData) {
                nonWaveBufferRef.current[serial].settingData = {};
              }
              Object.assign(nonWaveBufferRef.current[serial].settingData, data);
              nonWaveBufferRef.current[serial]._dirty = true;
            }
          })

          const userSettingTopic = `${isDemoMode ? '/demo' : ''}/user/topic/data/settings/${serial}`
          socketRef.current.subscribe(userSettingTopic, (message) => {
            const decompressed = decodeAndDecompress(message.body)
            if (decompressed) {
              const data = JSON.parse(decompressed);
              if (!nonWaveBufferRef.current[serial]) {
                nonWaveBufferRef.current[serial] = {};
              }
              if (!nonWaveBufferRef.current[serial].settingData) {
                nonWaveBufferRef.current[serial].settingData = {};
              }
              Object.assign(nonWaveBufferRef.current[serial].settingData, data);
              nonWaveBufferRef.current[serial]._dirty = true;
            }
          })

          const alarmTopic = `${isDemoMode ? '/demo' : ''}/topic/data/alarm/${serial}`
          socketRef.current.subscribe(alarmTopic, (message) => {
            const decompressed = decodeAndDecompress(message.body)
            if (decompressed) {
              const data = JSON.parse(decompressed);
              if (!nonWaveBufferRef.current[serial]) {
                nonWaveBufferRef.current[serial] = {};
              }
              nonWaveBufferRef.current[serial].alarmData = data;
              nonWaveBufferRef.current[serial]._dirty = true;
            }
          })

          const outOfRangeTopic = `${isDemoMode ? '/demo' : ''}/topic/data/outOfRangeAlarm/${serial}`
          socketRef.current.subscribe(outOfRangeTopic, (message) => {
            const decompressed = decodeAndDecompress(message.body)
            if (decompressed) {
              const data = JSON.parse(decompressed);
              if (!nonWaveBufferRef.current[serial]) {
                nonWaveBufferRef.current[serial] = {};
              }
              nonWaveBufferRef.current[serial].outOfRangeData = data;
              nonWaveBufferRef.current[serial]._dirty = true;
            }
          })
            
          const silenceTopic = `${isDemoMode ? '/demo' : ''}/topic/data/silence/${serial}`
          socketRef.current.subscribe(silenceTopic, (message) => {
            const decompressed = decodeAndDecompress(message.body)
            if (decompressed) {
              const data = JSON.parse(decompressed);
              if (!nonWaveBufferRef.current[serial]) {
                nonWaveBufferRef.current[serial] = {};
              }
              nonWaveBufferRef.current[serial].silenceData = data;
              nonWaveBufferRef.current[serial]._dirty = true;
            }
          })
            
          const bedInfoTopic = `${isDemoMode ? '/demo' : ''}/topic/data/bedInfo/${serial}`
          socketRef.current.subscribe(bedInfoTopic, (message) => {              
            const decompressed = decodeAndDecompress(message.body)              
            if (decompressed) {
              const data = JSON.parse(decompressed);                                

              if (!nonWaveBufferRef.current[serial]) {
                nonWaveBufferRef.current[serial] = {};
              }
              nonWaveBufferRef.current[serial].connectionStatus = data.connectionStatus === 'CONNECTED';
              nonWaveBufferRef.current[serial]._dirty = true;
              
              const hasBedData = data.bedNumber !== undefined 
                || data.name !== undefined 
                || data.devicePatientId !== undefined;
              
              if (!hasBedData) {
                  return;
              }

              if (!bedInfoQueueRef.current[serial]) {
                bedInfoQueueRef.current[serial] = [];
              }
              bedInfoQueueRef.current[serial].push(data);
              processBedInfoQueue(serial);
            }
          })

          // 🔥 단일 인터벌: 모든 serial의 waveData를 한 번에 처리
          const MAX_WAVE_LENGTH = 750;
          batchIntervalRef.current['__global__'] = setInterval(() => {
            let hasWaveChanges = false;
            let hasNonWaveChanges = false;

            // === wave 처리 ===
            const serials = Object.keys(batchUpdateRef.current);
            for (let i = 0; i < serials.length; i++) {
              const serial = serials[i];
              const batchData = batchUpdateRef.current[serial];

              if (!batchData || !batchData.dirty) continue;

              if (!bedDataRef.current[serial]) {
                bedDataRef.current[serial] = {};
              }
              const prevSerialData = bedDataRef.current[serial];
              const prevWaveData = prevSerialData.waveData || {};

              const newWaveData = {};
              const waveKeys = Object.keys(batchData.waveData);

              for (let j = 0; j < waveKeys.length; j++) {
                const key = waveKeys[j];
                const prevArray = prevWaveData[key] || [];
                const newArray = batchData.waveData[key];
                
                let combined;
                const totalLen = prevArray.length + newArray.length;
                if (totalLen > MAX_WAVE_LENGTH) {
                  const skipPrev = Math.max(0, totalLen - MAX_WAVE_LENGTH);
                  if (skipPrev >= prevArray.length) {
                    combined = newArray.slice(skipPrev - prevArray.length);
                  } else {
                    combined = prevArray.slice(skipPrev).concat(newArray);
                  }
                } else {
                  combined = prevArray.concat(newArray);
                }
                
                newWaveData[key] = combined;
              }
              
              Object.keys(prevWaveData).forEach(key => {
                if (!newWaveData[key]) {
                  let existing = prevWaveData[key];
                  if (existing.length > MAX_WAVE_LENGTH) {
                    existing = existing.slice(existing.length - MAX_WAVE_LENGTH);
                  }
                  newWaveData[key] = existing;
                }
              });

              // 🔥 해당 serial만 교체 (전체 bedDataRef spread 안 함)
              bedDataRef.current[serial] = {
                ...prevSerialData,
                waveData: newWaveData
              };

              for (let j = 0; j < waveKeys.length; j++) {
                batchData.waveData[waveKeys[j]].length = 0;
              }
              batchData.dirty = false;
              hasWaveChanges = true;
            }

            // === nonWave 처리: 버퍼 → bedDataRef로 flush ===
            const nonWaveSerials = Object.keys(nonWaveBufferRef.current);
            for (let i = 0; i < nonWaveSerials.length; i++) {
              const serial = nonWaveSerials[i];
              const buffer = nonWaveBufferRef.current[serial];
              if (!buffer || !buffer._dirty) continue;

              if (!bedDataRef.current[serial]) {
                bedDataRef.current[serial] = {};
              }
              const target = bedDataRef.current[serial];

              // 각 필드를 직접 교체 (spread 최소화)
              if (buffer.numericData) {
                target.numericData = { ...(target.numericData || {}), ...buffer.numericData };
                buffer.numericData = {};
              }
              if (buffer.settingData) {
                target.settingData = { ...(target.settingData || {}), ...buffer.settingData };
                buffer.settingData = {};
              }
              if (buffer.alarmData !== undefined) {
                target.alarmData = buffer.alarmData;
                delete buffer.alarmData;
              }
              if (buffer.outOfRangeData !== undefined) {
                target.outOfRangeData = buffer.outOfRangeData;
                delete buffer.outOfRangeData;
              }
              if (buffer.silenceData !== undefined) {
                target.silenceData = buffer.silenceData;
                delete buffer.silenceData;
              }
              if (buffer.connectionStatus !== undefined) {
                target.connectionStatus = buffer.connectionStatus;
                delete buffer.connectionStatus;
              }

              buffer._dirty = false;
              hasNonWaveChanges = true;
            }

            if (hasWaveChanges || hasNonWaveChanges) {
              bedDataVersionRef.current++;
            }
          }, 500);

          // HL7 Status 구독
          const hl7StatusTopic = `/topic/hl7/status`
          socketRef.current.subscribe(hl7StatusTopic, (message) => {
            const decompressed = decodeAndDecompress(message.body)
            if (decompressed) {
              const data = JSON.parse(decompressed);              
              setHl7Info(data);
            }
          })
        })
      },
      onDisconnect: (frame) => {
        console.log('[STOMP] Disconnected', frame);
      },
  
      onWebSocketClose: (evt) => {
        console.warn('[STOMP] WebSocket closed', evt);
        // 연결이 정상적으로 닫힌 경우가 아니라면 재연결 시도
        if (evt.code !== 1000 && evt.code !== 1001) {
          console.log('🔁 Unexpected close, attempting reconnect...');
          setTimeout(() => {
            if (socketInfo.length > 0) {
              connectWebsocket(socketInfo);
            }
          }, 3000);
        }
      },
  
      onWebSocketError: (evt) => {
        console.error('[STOMP] WebSocket error', evt);
      },
      onStompError: (frame) => {
        console.error('STOMP error', frame);
        socketRef.current.deactivate()
        socketRef.current = null
        setStompClient(null)

        setTimeout(() => {
          console.log('🔁 reconnecting manually...');
          connectWebsocket(socketInfo);
        }, 3000);
      },
    });
  
    socketRef.current.activate();
    setStompClient(socketRef.current);
  };

  const connectSecondsWebsocket = () => {
    if (audioSocketRef.current) {
      if (audioSocketRef.current.cleanup) audioSocketRef.current.cleanup(); //out of memory 방지 위해 기존 인터벌 정리
      audioSocketRef.current.close()
      audioSocketRef.current = null
    }

    const wsUrl = `ws://127.0.0.1:9123`;
    audioSocketRef.current = new WebSocket(wsUrl);

    audioSocketRef.current.onopen = () => {
      console.log('[Native WebSocket] Connected');
      sendNativeMessage('check');
    };

    audioSocketRef.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('[Native WebSocket] Message received:', data);
        if (data) {
          setAudioErrorType(null)
          setAudioModalShow(false)
        } else {
          handleAudioModal('open', 'connection')
        }
      } catch (error) {
        console.error('[Native WebSocket] Parse error:', error);
      }
    };

    audioSocketRef.current.onclose = (event) => {
      console.log('[Native WebSocket] Closed:', event.code, event.reason);
      handleAudioModal('open', 'warning')
    };

    audioSocketRef.current.onerror = (error) => {
      console.error('[Native WebSocket] Error:', error);
      handleAudioModal('open', 'warning')
    };

    const checkConnectionStatus = () => {
      if (audioSocketRef.current) {
        console.log('[Native WebSocket] ReadyState:', audioSocketRef.current.readyState);
        
        // WebSocket 상태: 0=CONNECTING, 1=OPEN, 2=CLOSING, 3=CLOSED
        if (audioSocketRef.current.readyState === WebSocket.CLOSED || audioSocketRef.current.readyState === WebSocket.CONNECTING) {
          console.warn('[Native WebSocket] Connection is closed but onclose was not triggered');
          handleAudioModal('open', 'warning');
        }
      }
    };

    // 주기적으로 연결 상태 확인 (5초마다)
    const statusCheckInterval = setInterval(() => {
      if (audioSocketRef.current) {
        checkConnectionStatus();
      } else {
        clearInterval(statusCheckInterval);
      }
    }, 3000);

    // Ping/Pong으로 연결 상태 확인
    const pingInterval = setInterval(() => {
      if (audioSocketRef.current && audioSocketRef.current.readyState === WebSocket.OPEN) {
        try {
          sendNativeMessage('ping');
        } catch (error) {
          console.error('[Native WebSocket] Ping failed:', error);
          handleAudioModal('open', 'warning');
        }
      }
    }, 3000); // 3초마다 ping

    // cleanup 함수 저장
    audioSocketRef.current.cleanup = () => {
      clearInterval(statusCheckInterval);
      clearInterval(pingInterval);
    };
  };

// Native WebSocket으로 메시지 전송
const sendNativeMessage = (message) => {
  if (audioSocketRef.current && audioSocketRef.current.readyState === WebSocket.OPEN) {
    audioSocketRef.current.send(JSON.stringify(message));
  }
};

const createBedArr = (deviceArr, start, count) => {
  const deviceFiltered = deviceArr.filter(device => device.displayOrder > start && device.displayOrder <= start + count)
  const bedInfoItem = []
  for(let i = start + 1; i <= start + count; ++i) {
      const targetDevice = deviceFiltered.find(device => device.displayOrder === i)
      bedInfoItem.push(targetDevice ? targetDevice : { bedNumber: '' })
  }
  return bedInfoItem
}

const setUnitInfo = (categories) => {
  if (!categories) return
  let nibpUnit = categories.find(category => category.name === 'NIBP')
  nibpUnit = nibpUnit.unit || nibpUnit.defaultUnit

  let ibpUnit = categories.find(category => category.name === 'IBP')
  ibpUnit = ibpUnit.unit || ibpUnit.defaultUnit

  let co2Unit = categories.find(category => category.name === 'CO2')
  co2Unit = co2Unit.unit || co2Unit.defaultUnit

  let tempUnit = categories.find(category => category.name === 'TEMP')
  tempUnit = tempUnit.unit || tempUnit.defaultUnit

  let gasUnit = categories.find(category => category.name === 'GAS')
  gasUnit = gasUnit.unit || gasUnit.defaultUnit

  setUnits({
    ...units,
    'NIBP': nibpUnit,
    'IBP': ibpUnit,
    'IBP1': ibpUnit,
    'IBP2': ibpUnit,
    'IBP3': ibpUnit,
    'IBP4': ibpUnit,
    'EtCO2': co2Unit,
    'InCO2': co2Unit,
    'Temp': tempUnit,
    'Temp1': tempUnit,
    'Temp2': tempUnit,
    'GAS': gasUnit
  })
}

const createBedInfo = (bedInfoArr, monitorData) => {
  return bedInfoArr.map(item => {
    return {
      ...item,
      displaySize: monitorData.bedTextSize === 'LARGE' ? 'Large' : 'Small',
      nameDisplay: item.displayDevicePatientId && item.displayPatientName ? '3' : item.displayDevicePatientId ? '2' : '1',
      numericCodeList: item.numericSettings?.map(numericSetting => numericSetting.measureParameter),
      waveCodeList: item.waveSettings?.map(waveSetting => waveSetting.measureParameter)
    }
  })
}

const handleChangeWard = async (ward) => {
    try {
        let isChangeWard = false; //와드 변경으로 인한 처음 세팅일 경우 
        if (ward) {
            setCurWard(ward)
            setCurMonitor(1);
            isChangeWard = true;
        }
        const unitRes = await axios.get(`/measure/parameter/categories`)
        setUnitInfo(unitRes.data.categories)

        const wardSettingRes = await axios.get(`/ward/${ward ? ward.value : curWard.value}/dashboard/setting/${isChangeWard ? 1 : (curMonitor ? curMonitor : 1)}`)
        if (wardSettingRes.code != '200') throw wardSettingRes
        const wardSettingResData = wardSettingRes.data
        const newBedInfo = []
        let startIndex = 0;          

        const newCnt = [wardSettingResData.leftBedCount, wardSettingResData.rightBedCount]
        for (let size of newCnt) {
            const bedInfoItem = createBedArr(wardSettingResData.devices, startIndex, size)
            newBedInfo.push(createBedInfo(bedInfoItem, wardSettingResData));
            startIndex += size;
        }        
        
        const waveParameterColors = wardSettingResData.waveParameterColors || [];
        const numericParameterColors = wardSettingResData.numericParameterColors || [];
        handleSetparameterColors(waveParameterColors, numericParameterColors);   
        
        setCnt(newCnt)        
        console.log('1set')
        console.log('1set newBedInfo : ', newBedInfo);
        localStorage.removeItem("leftHeight");
        localStorage.removeItem("rightHeight");
        setBedInfo(newBedInfo)                    
        setSocketInfo(wardSettingResData.devices)
        localStorage.removeItem('bedInfo')
        localStorage.removeItem('socketInfo')
        setActivePanel(null);
        setFullPanel(null);
    } catch (err) { 
        console.warn(err);
        setBedInfo([])
        // Toast({ isSuccess: false , msg : `Failed to get bed info.` });
    }
};

  const handleCloseBottom = useCallback((newValue) => {        
    if ((activePanel == 'settings') && newValue) {
      // 설정창 + 신규 세팅
      // setCnt(newValue)
      handleChangeWard();
      localStorage.removeItem("leftHeight");
      localStorage.removeItem("rightHeight");
    } else {
      if (!(activePanel == 'settings') || !(activePanel == 'userInfo')) {
        setSelectBedInfo(null);
      }
      setCnt(JSON.parse(localStorage.getItem("cnt")));      
      console.log("2set");      
      setBedInfo(JSON.parse(localStorage.getItem("bedInfo")));
      setSocketInfo(JSON.parse(localStorage.getItem("socketInfo")));      
    }
    setActivePanel(null);
    setFullPanel(null);
    //localStorage.removeItem("cnt");
  }, [activePanel]);

  const handleChangeDisplay = async (isLeft) => {
    try {
      // ward.value
      let targetWrapperInfo = [];
      if (isLeft) {
        targetWrapperInfo = leftPatientWrapperRef.current.getHeightInfo();
      } else {
        targetWrapperInfo = rightPatientWrapperRef.current.getHeightInfo();
      }
      const unitRes = await axios.get(`/measure/parameter/categories`)
      setUnitInfo(unitRes.data.categories)
      const wardSettingRes = await axios.get(`/ward/${curWard.value}/dashboard/setting/${curMonitor ? curMonitor : 1}`)
      if (wardSettingRes.code != '200') throw wardSettingRes
      const wardSettingResData = wardSettingRes.data
      
      let startIndex = isLeft ? 0 : 0 + cnt[0];
      let targetCount = (isLeft ? cnt[0] : cnt[1])
      const bedInfoItem = createBedArr(wardSettingResData.devices, startIndex, targetCount)
      // const bedInfoItem = wardSettingResData.devices.slice(startIndex, startIndex + (isLeft ? cnt[0] : cnt[1]))
      const newBedInfo = [...bedInfo];
      newBedInfo[isLeft ? 0 : 1] = createBedInfo(bedInfoItem, wardSettingResData);
      console.log("3set");

      const waveParameterColors = wardSettingResData.waveParameterColors || [];
      const numericParameterColors = wardSettingResData.numericParameterColors || [];
      handleSetparameterColors(waveParameterColors, numericParameterColors);

      setBedInfo(newBedInfo);
      setSocketInfo(wardSettingResData.devices);
    } catch (err) {
      console.warn(err);
      router.navigate('/')
    }
  };

  const handleChangeDisplayForHalfDashboard = useCallback(async () => {
    try {      
      localStorage.setItem("bedInfo", JSON.stringify(bedInfo));
      localStorage.setItem("socketInfo", JSON.stringify(socketInfo));
      localStorage.setItem("cnt", JSON.stringify(cnt));
      leftPatientWrapperRef.current.saveHeightInfo("left");
      rightPatientWrapperRef.current.saveHeightInfo("right");
      const leftWrapperInfo = leftPatientWrapperRef.current.getHeightInfo();
      const rightWrapperInfo = rightPatientWrapperRef.current.getHeightInfo();
      const unitRes = await axios.get(`/measure/parameter/categories`)
      setUnitInfo(unitRes.data.categories)
      const wardSettingRes = await axios.get(`/ward/${curWard.value}/dashboard/setting/${curMonitor ? curMonitor : 1}`)
      if (wardSettingRes.code != '200') throw wardSettingRes
      const wardSettingResData = wardSettingRes.data

      const newCnt = getHalfBedArr();
      setCnt(newCnt);

      const newBedInfo = [];
      let startIndex = 0;

      for (let size of newCnt) {
        const bedInfoItem = createBedArr(wardSettingResData.devices, startIndex, size)
        // const bedInfoItem = wardSettingResData.devices.slice(startIndex, startIndex + size)
        newBedInfo.push(createBedInfo(bedInfoItem, wardSettingResData));
        startIndex += size;
      }
      console.log("4set");
      const waveParameterColors = wardSettingResData.waveParameterColors || [];
      const numericParameterColors = wardSettingResData.numericParameterColors || [];
      handleSetparameterColors(waveParameterColors, numericParameterColors);            
      setBedInfo(newBedInfo);
      setSocketInfo(wardSettingResData.devices);      
    } catch (err) {
      console.warn(err);
      router.navigate('/')
    }
  }, [bedInfo, socketInfo, cnt, curWard, curMonitor]);

  const handleSaveHalfDashboard = async (savedBedInfo, newCnt) => {
    // newBedInfo -> [{ bedNumber, patientId }]
    // newCnt -> [4,4,4,4]
    const unitRes = await axios.get(`/measure/parameter/categories`)
    setUnitInfo(unitRes.data.categories)
    const wardSettingRes = await axios.get(`/ward/${curWard.value}/dashboard/setting/${curMonitor ? curMonitor : 1}`)
    if (wardSettingRes.code != '200') throw wardSettingRes
    const wardSettingResData = wardSettingRes.data

    console.log("handleSaveHalfDashboard :", wardSettingRes);

    setCnt(newCnt);

    const newBedInfo = [];
    let startIndex = 0;

    for (let size of newCnt) {
      const bedInfoItem = createBedArr(wardSettingResData.devices, startIndex, size)
      // const bedInfoItem = wardSettingResData.devices.slice(startIndex, startIndex + size)
      newBedInfo.push(createBedInfo(bedInfoItem, wardSettingResData));
      startIndex += size;
    }
    console.log("5set");
    const waveParameterColors = wardSettingResData.waveParameterColors || [];
    const numericParameterColors = wardSettingResData.numericParameterColors || [];
    handleSetparameterColors(waveParameterColors, numericParameterColors);
    setBedInfo(newBedInfo);
    setSocketInfo(wardSettingResData.devices);
  };

  const handleSaveParameter = async () => {
    try {
      // ward.value
      const unitRes = await axios.get(`/measure/parameter/categories`)
      setUnitInfo(unitRes.data.categories)
      const wardSettingRes = await axios.get(`/ward/${curWard.value}/dashboard/setting/${curMonitor ? curMonitor : 1}`)
      if (wardSettingRes.code != '200') throw wardSettingRes
      const wardSettingResData = wardSettingRes.data      
      const newBedInfo = [];
      const fullDashboardBedInfo = [];
      let startIndex = 0;
      const fullDashboardCnt = JSON.parse(localStorage.getItem("cnt"));

      for (let size of fullDashboardCnt) {
        const bedInfoItem = createBedArr(wardSettingResData.devices, startIndex, size)
        // const bedInfoItem = wardSettingResData.devices.slice(startIndex, startIndex + size)
        fullDashboardBedInfo.push(createBedInfo(bedInfoItem, wardSettingResData));
        startIndex += size;
      }
      startIndex = 0;
      for (let size of cnt) {
        const bedInfoItem = createBedArr(wardSettingResData.devices, startIndex, size)
        // const bedInfoItem = wardSettingResData.devices.slice(startIndex, startIndex + size)
        newBedInfo.push(createBedInfo(bedInfoItem, wardSettingResData));
        startIndex += size;
      }
      console.log("6set");
      const waveParameterColors = wardSettingResData.waveParameterColors || [];
      const numericParameterColors = wardSettingResData.numericParameterColors || [];
      handleSetparameterColors(waveParameterColors, numericParameterColors);      
      setBedInfo(newBedInfo);
      setSocketInfo(wardSettingResData.devices);
      localStorage.setItem("bedInfo", JSON.stringify(fullDashboardBedInfo));
      localStorage.setItem( "socketInfo", JSON.stringify(wardSettingResData.devices)
      );
    } catch (err) {
      console.warn(err);
      router.navigate('/')
    }
  };

  const handleTrend = useCallback(() => {
    setActivePanel('trend');
    setFullPanel(null);

    if (!activePanel) {
      handleChangeDisplayForHalfDashboard();
    }
  }, [activePanel, handleChangeDisplayForHalfDashboard]);

  const handleAlarmReview = useCallback((flag) => {
    setActivePanel('alarmReview');
    setFullPanel(null);

    if (!activePanel) {
      handleChangeDisplayForHalfDashboard();
    }
  }, [activePanel, handleChangeDisplayForHalfDashboard]);
  //Bed Settings
  const handleBedSetting = useCallback((flag) => {
    setActivePanel('bedSettings');
    setFullPanel(null);

    if (!activePanel) {
      handleChangeDisplayForHalfDashboard();
    }
  }, [activePanel, handleChangeDisplayForHalfDashboard]);

  const handleMeasurements = useCallback(() => {
    setActivePanel('measurements');
    setFullPanel(null);

    if (!activePanel) {
      handleChangeDisplayForHalfDashboard();
    }
  }, [activePanel, handleChangeDisplayForHalfDashboard]);
  const handleOpenSettings = useCallback(() => {
    setActivePanel('settings');
    setFullPanel(null);
    setSelectBedInfo(null);

    if (!activePanel) {
      handleChangeDisplayForHalfDashboard();
    }
  }, [activePanel, handleChangeDisplayForHalfDashboard]);  

  const handleOpenUserInfo = useCallback(() => {
    setActivePanel('userInfo')
    setFullPanel(null)
    setSelectBedInfo(null)

    if (!activePanel) {
      handleChangeDisplayForHalfDashboard();
    }
  }, [activePanel, handleChangeDisplayForHalfDashboard]);

  const handleOpenUserSetting = useCallback(() => {
    setActivePanel('userSetting')
    setFullPanel(null)
    setSelectBedInfo(null)

    if (!activePanel) {
      handleChangeDisplayForHalfDashboard();
    }
  }, [activePanel, handleChangeDisplayForHalfDashboard]);

  // ✅ DeepSight Info
  const handleOpenDeepSightInfo = () => {
      setIsDeepSightInfoOpen(true) 
  }

  //Rodney - OneBed Dashboard 세팅
  const handleOpenOneBed = useCallback((flag,Idx) => {     
      switch (flag) {
        case "open":
          setActivePanel('OneBed');
          setFullPanel('OneBed');
          setPatientIdx(Idx);         
          
          if (!activePanel) {
            handleChangeDisplayForHalfDashboard();
          }

          break;
      }         
  }, [activePanel, handleChangeDisplayForHalfDashboard]);

  const handleFullScreen = useCallback(() => {
      setFullPanel(fullPanel === 'trend' ? null : 'trend');
  }, [fullPanel]);
  
  const handleAlarmFullScreen = useCallback(() => {
      setFullPanel(fullPanel === 'alarmReview' ? null : 'alarmReview');
  }, [fullPanel]);  

  const getHalfBedArr = useCallback(() => {
    const resultArr = [];
    cnt.forEach((num) => {
      switch (num) {
        case 8:
          resultArr.push(...[4, 4]);
          break;
        case 7:
          resultArr.push(...[4, 3]);
          break;
        case 6:
          resultArr.push(...[3, 3]);
          break;
        case 5:
          resultArr.push(...[3, 2]);
          break;
        case 4:
          resultArr.push(...[2, 2]);
          break;
        case 3:
          resultArr.push(...[2, 1]);
          break;
        case 2:
          resultArr.push(...[1, 1]);
          break;
      }
    });
    return resultArr;
  }, [cnt]);

  // Print 기능
  const handlePrint = (bedInfo) => {
      //V20 프린트 로직 추가 해야됨.      
      if(bedInfo.deviceModel == 'V20'){
        const payloads = {
            bedInfo: bedInfo,
            v20Data: v20Datas[bedInfo.serial] || null
        }

        console.log('payloads : ', payloads);

        const setUrl = `${window.location.origin}/print/v20form`;
        const windowFeatures = "width=1200,height=800,left=100,top=100,scrollbars=yes,resizable=yes";
        const newWindow = window.open(setUrl, "_blank",windowFeatures);

        if (newWindow) {
            const handleReady = (event) => {
                if (event.data?.name === "READY") {
                    newWindow.postMessage({
                        name: "LOAD_REPORT_DATA",
                        type: "Print",
                        payload: payloads
                    }, "*");
                    window.removeEventListener("message", handleReady);
                }
            };
            window.addEventListener("message", handleReady);
        } else {
          alert("팝업이 차단되었습니다. 브라우저 설정에서 팝업 허용을 해주세요.");
        }
      }else{
        const nowDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]');      
        const deviceId = bedInfo.deviceId;
        const setUrl = `${window.location.origin}/print/waveform?deviceid=${deviceId}&date=${nowDate}`;
        
        setIsPrintCountOpen(true);
        setPrintCountdown(15); // 초기 카운트다운 값 설정

        // 15초 동안 볼 수 있는 프린트 카운트 다운 기능
        const countdownInterval = setInterval(() => {
            setPrintCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(countdownInterval);                  
                    setIsPrintCountOpen(false); // 모달 닫기
                    
                    const windowFeatures = "width=1200,height=800,left=100,top=100,scrollbars=yes,resizable=yes";
                    const newWindow = window.open(setUrl, "popupWindow", windowFeatures);

                    if (newWindow) {
                      newWindow.focus();
                    } else {
                      alert("팝업이 차단되었습니다. 브라우저 설정에서 팝업 허용을 해주세요.");
                    }
                }
                return prev - 1;
            });
        }, 1000);
      }
  }

  const handleStorage = (event) => {
    if (event.key === "serverError") {
      if (event.newValue) {
        router.navigate('/')
      }
    }
  };

  //Setup - Patient 데이터 변경 후 DashBoard 적용
  const handlePatientDataChange = (payload) => {
    const patientMap = new Map(
      payload.map((patient) => [patient.patientId, patient])
    );    

    const oldFullDashboardBedInfo = JSON.parse(localStorage.getItem("bedInfo"));
    const newFullDashboardBedInfo = oldFullDashboardBedInfo.map((group) =>
      group.map((bedItem) => {
        const matchingPatient = patientMap.get(bedItem.patientId);

        if (matchingPatient) {
          return {
            ...bedItem,
            name: matchingPatient.name,
            patientId: matchingPatient.patientId,
          };
        }
        return bedItem;
      })
    );

    //BedInfo LocalStorage 저장
    localStorage.setItem("bedInfo", JSON.stringify(newFullDashboardBedInfo));

    //BedInfo 데이터 재 설정
    const newBedArray = newFullDashboardBedInfo.flat();
    const newBedInfo = [];
    let startIndex = 0;

    for (const size of cnt) {
      newBedInfo.push(newBedArray.slice(startIndex, startIndex + size));
      startIndex += size;
    }

    setBedInfo(newBedInfo);
  };

  const fetchLayout = async (monitor, ward) => {
    if (!monitor || !ward) return;
    const unitRes = await axios.get(`/measure/parameter/categories`)
    setUnitInfo(unitRes.data.categories)
    const res = await axios.get(`/ward/${ward}/dashboard/setting/${monitor}`);
    if (res.code !== 200) return;
    const data = res.data;
  
    setCnt([data.leftBedCount, data.rightBedCount]);

    const newBedInfo = [];
    let startIndex = 0;
    const cntArr = [data.leftBedCount, data.rightBedCount];
  
    for (let size of cntArr) {
      const bedInfoItem = createBedArr(data.devices, startIndex, size);
      newBedInfo.push(createBedInfo(bedInfoItem, data));
      startIndex += size;
    }
  
    console.log("7set");
    // 파라미터 컬러 설정
    const waveParameterColors = data.waveParameterColors || [];
    const numericParameterColors = data.numericParameterColors || [];
    handleSetparameterColors(waveParameterColors, numericParameterColors);

    console.log('newBedInfo : ', newBedInfo);
    setBedInfo(newBedInfo);
    setSocketInfo(data.devices);
    localStorage.setItem("bedInfo", JSON.stringify(newBedInfo));
    localStorage.setItem("socketInfo", JSON.stringify(data.devices));
    localStorage.setItem("cnt", JSON.stringify(cntArr));
    setActivePanel(null)
    setFullPanel(null)
  };

  //Monitor 1,2 settings
  const handleCurMonitor = (monitor) => {
    console.log('handleCurMonitor : ', monitor)
    setCurMonitor(monitor);
    localStorage.removeItem("leftHeight");
    localStorage.removeItem("rightHeight");
    fetchLayout(monitor, curWard && curWard.value ? curWard.value : curWard);
  }

  //Parameter 컬러 설정
  const handleSetparameterColors = (waveColors, numericColors) => {
    let arrWaveColors;
    let arrNumericColors;

    // waveColors가 빈 배열이 아니고 값이 있으면 변환, 아니면 default 사용
    if (Array.isArray(waveColors) && waveColors.length > 0) {
        arrWaveColors = parameterArrayToObject(waveColors);
    } else if (defaultWaveParameterColors) {
        arrWaveColors = defaultWaveParameterColors;
    } else {
        arrWaveColors = {};
    }

    // numericColors가 빈 배열이 아니고 값이 있으면 변환, 아니면 default 사용
    if (Array.isArray(numericColors) && numericColors.length > 0) {
        arrNumericColors = parameterArrayToObject(numericColors);
    } else if (defaultNumericParameterColors) {
        arrNumericColors = defaultNumericParameterColors;
    } else {
        arrNumericColors = {};
    }

    setParameterColors({
        waveParameterColors: arrWaveColors,
        numericParameterColors: arrNumericColors
    });
  }

  const handleAudioModal = (flag, modalType) => {
    switch(flag) {
      case 'open':
        setAudioErrorType(modalType)
        setAudioModalShow(true);
        break;
      case 'retry':
        connectSecondsWebsocket()
        break;
      case 'ok':
        if (audioErrorType === 'autoPlay') {
          setAudioModalShow(false)
        } else if (audioErrorType === 'connection') {
          setAudioModalShow(false)
        } else if (audioErrorType === 'warning') {
          if (audioSocketRef.current) {
            audioSocketRef.current.close()
            audioSocketRef.current = null
          }
          setAudioDismiss(true)
          setAudioModalShow(false)
        }
        setPlayAudio(true)
        break;
    }
  }

  const getDeviceModelInfo = async () => {
    try {
      const deviceModelRes = await axios.get('/device-models')
      console.log('deviceModelRes', deviceModelRes);
      if (deviceModelRes.code != '200') throw deviceModelRes
      setDeviceModelInfo(deviceModelRes.data.deviceModels)
    }
    catch (err) { 
      console.warn(err)
    }
  }

  useEffect(() => {
    if (!playAudio && !audioModalShow){
      handleAudioModal('open', 'autoPlay')
    }
  }, [playAudio, audioModalShow])

  useEffect(() => {
    const handleFullscreenChange = () => {
      fullScreenRef.current += 1;
    };

    window.addEventListener("resize", handleFullscreenChange);
    window.addEventListener("storage", handleStorage);

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        // console.log('forground')
        // console.log(socketRef.current)
      }
    })
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("resize", handleFullscreenChange);
      // 모든 인터벌 정리
      Object.values(batchIntervalRef.current).forEach(interval => {
        if (interval) clearInterval(interval);
      });
      // clearInterval(pingInterval);
      if (socketRef.current) {
        socketRef.current.deactivate();
        socketRef.current = null
        setStompClient(null)
      }
    };
  }, []);

  useEffect(() => {
    if (!selectBedInfo) {
      setIsFromSearch(false)
    }
  }, [selectBedInfo])

  useEffect(() => {
    if (socketInfo.length > 0) {
      connectWebsocket(socketInfo);
    }
  }, [socketInfo]);

  useEffect(() => {
    if(isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
  }, [curMonitor]);

  useEffect(() => {
    if (searchModalShow) {
      searchModalRef.current?.init()
    }
  }, [searchModalShow])

  useEffect(() => {
    if (leadModalShow) {
      leadModalRef.current?.init()
    }
  }, [leadModalShow])

  useEffect(() => {
    let lastSyncVersion = 0;

    const interval = setInterval(() => {
      if (bedDataVersionRef.current === lastSyncVersion) return;
      lastSyncVersion = bedDataVersionRef.current;
      
      createSnapshot();
    }, 500)    
    
    const isWindows = /Windows/.test(navigator.userAgent)
    if (isWindows) {
      connectSecondsWebsocket()
    }

    getDeviceModelInfo();
    const lang = localStorage.getItem('lang') || 'en'    
    i18n.changeLanguage(lang)

    const demoMode = localStorage.getItem('demoMode')        
    setDemoModeState(demoMode === 'true');

    return () => { 
      clearInterval(interval)
      
      if (audioSocketRef.current) {
        if (audioSocketRef.current.cleanup) audioSocketRef.current.cleanup();
        audioSocketRef.current.close()
        audioSocketRef.current = null
      }
    };
  }, [])

  // PatientWrapper 높이
  const wrapperHeight = activePanel ? "calc(50% - 20px)" : "calc(100% - 40px)";      

  const handleLogout = async (flag) => {
    try {
      const res = await axios.delete('/auth/logout')
      if (res.code != '200') throw res
      localStorage.removeItem('accessToken')
      localStorage.removeItem('lang')      
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('cmsUserId')
      router.navigate('/')
    } catch (err) {
      Toast({ isSuccess: false , msg : t('error.retryLater') });
    }
  }

  const handleChangeWardUnSilence = () => {
    setWardStatusChangeFlag(wardStatusChangeFlag + 1)
  }

  //StandBy 모드 Confirm창 변경
  const handleStandByConfirm = (deviceId) => {
    setIsStandByConfirmOpen(true)
    setStandByDevice(deviceId);
  }
  
  const handleClickStandby = async () => {
      try {            
          const payload = {
              standbyMode: false
          }
          const res = await axios.patch(`/device/${standByDevice}/standby`,payload);            
          if (res.code != '200') throw res            
          setIsStandByConfirmOpen(false)        
                    
          const newBedInfo = bedInfo.map(beds =>
            beds.map(bed =>
              bed.deviceId === standByDevice
                ? { ...bed, standbyMode: false }
                : bed
            )
          );
          setBedInfo(newBedInfo);
      } catch (err) {
          console.warn(err)
      }
  }

  const handleOpenPatientSearch = () => {
    setSearchModalShow(true)
  }

  const handlePatientSearch = (searchedPatient, deviceHistory) => {
    console.log('handlePatientSearch : ', searchedPatient, deviceHistory);    
    const now = moment();

    setSelectBedInfo({
        ...searchedPatient,
        patientName: searchedPatient.name,
        bedNumber: '',
        nameDisplay: '3',
        startTime: moment(searchedPatient.createdAt),
        endTime: searchedPatient.status === 'ADMITTED' ? now : moment(searchedPatient.updatedAt),
        deviceModel : deviceHistory[0].model ? deviceHistory[0].model : '',
        deviceHistory
      })
    setIsFromSearch(true)

    // Alarm Review에서 보고 있으면 alarmReview Open
    if(activePanel == 'alarmReview'){
        handleAlarmReview('open') // 나중에 trend로 변경
    }else{
        handleTrend()
    }
  }

  return (
    <>
      <div className={`flex flex-col ${(fullPanel) ? "relative" : ""}`} style={{ width: "100%", height: "100%" }}>
        <Header
          handleChangeWard={handleChangeWard}
          wardStatusChangeFlag={wardStatusChangeFlag}
          onSettingsClick={() => handleOpenSettings()}
          onLeadModalClick={() => setLeadModalShow(true)}
          onLogoutClick={() => { handleLogout('open')}}
          onUserInfoClick={() => handleOpenUserInfo()}
          onUserSettingClick={() => handleOpenUserSetting()}
          onOpenDeepSightInfo={() => handleOpenDeepSightInfo()}
          onSearchClick={() => { handleOpenPatientSearch() }}
          handleChangeWardStatus={handleChangeWardUnSilence}
          handleBedSetting={handleBedSetting}       
          curMonitor={curMonitor}
          handleCurMonitor={handleCurMonitor}          
        />
        <div
          className="flex"
          style={{ width: "100%", height: wrapperHeight, minHeight: 520 }}
        >
          {
            activePanel !== 'OneBed' &&
            (cnt || []).map((node, idx) => {
              return (
                <PatientWrapper
                  ref={idx === 0 ? leftPatientWrapperRef : rightPatientWrapperRef}
                  bedInfo={bedInfo[idx] || []}
                  bedData={bedDataSnapshot}
                  key={`patient-wrapper-${cnt.length}-${idx}-${fullScreenRef.current}`}
                  updateKey={`patient-wrapper-${cnt.length}-${idx}-${fullScreenRef.current}`}
                  patientCnt={node}
                  isLeft={idx === 0}
                  isFirst={idx === 0}
                  isHalf={activePanel ?  true : false}
                  wardStatusChangeFlag={wardStatusChangeFlag}
                  handleInitWardStatusChangeFlag={setWardStatusChangeFlag}
                  handleChangeDisplay={handleChangeDisplay}
                  handleTrend={handleTrend}
                  handleAlarmReview={handleAlarmReview}
                  handleBedSetting={handleBedSetting}       
                  handleOpenOneBed={handleOpenOneBed} 
                  handleStandByConfirm={handleStandByConfirm}
                  handleMeasurements={handleMeasurements}
                  handlePrint={handlePrint}
                  // alarms={alarms}
                  // handleSilence={handleSilence}
                  // handleUnsilence={handleUnsilence}
                  // remainingSeconds={remainingSeconds}
                  // isSilenced={isSilenced}
                />
              );
            })
          }
        </div>
        {(activePanel) && (
            <div
                className={`${
                  fullPanel === 'trend' || fullPanel === 'alarmReview' || fullPanel === 'OneBed' ? "full-bottom z-[1000]" : ""
                }`}
                style={{ height: "calc(100% - 560px)" }}
              >
            {activePanel == 'settings' && (
              <SettingsModal
                onClose={handleCloseBottom}
                handleSaveHalfDashboard={handleSaveHalfDashboard}                
                handleSaveParameter={handleSaveParameter}
              />
            )}
            {activePanel == 'userInfo' && (
              <UserInfoModal
                onClose={handleCloseBottom}
              />
            )}
            {activePanel == 'userSetting' && (
              <UserSettingModal
                onClose={handleCloseBottom}
              />
            )}
            {activePanel == 'trend' && (
              <div className="flex-1 w-full" style={{ height: "100%" }}>
                {
                  selectBedInfo?.deviceModel == 'V20' ? (
                    <TrendReviewV20
                      isTrendFull={fullPanel === 'trend'}
                      onClose={handleCloseBottom}
                      onAlarmReview={handleAlarmReview}
                      onSetting={handleBedSetting}
                      onMeasurements={handleMeasurements}
                      handleFullScreen={handleFullScreen}
                    />
                  ) : (
                    <TrendReview
                      isTrendFull={fullPanel === 'trend'}
                      onClose={handleCloseBottom}
                      onAlarmReview={handleAlarmReview}
                      onSetting={handleBedSetting}
                      onMeasurements={handleMeasurements}
                      handleFullScreen={handleFullScreen}
                    />
                  )
                }
              </div>
            )}
            
            {activePanel == 'alarmReview' && (
              <div className="flex-1 w-full" style={{ height: "100%" }}>
                <AlarmReview
                  //isAlarmFull={isAlarmFull}
                  isAlarmFull={fullPanel === 'alarmReview'}
                  onClose={handleCloseBottom}
                  onTrend={handleTrend}
                  onMeasurements={handleMeasurements}
                  onSetting={handleBedSetting}
                  handleFullScreen={handleAlarmFullScreen}
                />
              </div>
            )}
            {activePanel == 'measurements' && (
              <div className="flex-1 w-full" style={{ height: "100%" }}>
                <Measurements
                  onClose={handleCloseBottom}
                  onTrend={handleTrend}
                  onAlarmReview={handleAlarmReview}
                  onSetting={handleBedSetting}
                  handleSaveParameter={handleSaveParameter}
                />
              </div>
            )}
            {activePanel == 'bedSettings' && (
              <div className="flex-1 w-full" style={{ height: "100%" }}>
                <BedSettingsModal
                  onClose={handleCloseBottom}
                  onTrend={handleTrend}
                  onAlarmReview={handleAlarmReview}
                  onMeasurements={handleMeasurements}
                  handleSaveParameter={handleSaveParameter}
                />
              </div>
            )}
            {activePanel == 'OneBed' && (
              <div className="flex-1 w-full" style={{ height: "100%" }}>
                <OneBed
                  onClose={handleCloseBottom}
                  handleTrend={handleTrend}
                  handleAlarmReview={handleAlarmReview}
                  handleBedSetting={handleBedSetting}
                  handleMeasurements={handleMeasurements}
                  handleStandByConfirm={handleStandByConfirm}
                  handlePrint={handlePrint}
                />
              </div>
            )}

          </div>
        )}
      </div>
      <Modal 
        isOpen={isLogoutConfirmOpen}
        title={'Logout'}
        message={'logout?'}
        isConfirm={true}
        confirmText={'Logout'}
        onConfirm={() => { handleLogout('confirm') }}
        onCancel={() => { handleLogout('cancel') }}
      />
      <Modal 
        isOpen={isStandByConfirmOpen}
        title={t('dashboard.resume')}
        message={t('dashboard.resumeConfirm')}
        isConfirm={true}
        confirmText={t('dashboard.ok')}
        onConfirm={() => { handleClickStandby() }}
        onCancel={() => { setIsStandByConfirmOpen(false) }}
      />
      <Modal 
        type={3}
        isOpen={isPrintCountOpen}
        title={t('dashboard.PrintTitle')}
        message={t('dashboard.PrintMessage', { time: printCountdown })}
        isConfirm={false}
        confirmText={'OK'}
        onConfirm={false}
        onCancel={() => { setIsPrintCountOpen(false) }}
      />

        {/* setIsCms2InfoOpen */}
        <DeepSightInfo
          isOpen={isDeepSightInfoOpen}
          title={t('dashboard.infoModalTitle')}
          message={''}
          onOk={() => { setIsDeepSightInfoOpen(false) }}
          onCancel={() => { setIsDeepSightInfoOpen(false) }}
        />
      {
        searchModalShow &&
        <SearchPatientModal ref={searchModalRef} handleSelect={handlePatientSearch} handleClose={() => { setSearchModalShow(false) }} />
      }
      {
        leadModalShow &&
        <LeadModal ref={leadModalRef} handleClose={() => { setLeadModalShow(false) }} />
      }
      {
        !audioDismiss && audioModalShow &&
        <AudioModal type={audioErrorType} handleOk={() => { handleAudioModal('ok') }} handleRetry={() => { handleAudioModal('retry') }} handleClose={() => { handleAudioModal('close') }} />
      }
    </>
  );
};
export default Dashboard;